import * as React from 'react'; // eslint-disable-line

import SVGBase from '../svg-base/svg-base';

export interface SpotlightLogoProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const SpotlightLogo: React.FunctionComponent<React.PropsWithChildren<SpotlightLogoProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}): any => (
    <SVGBase viewBox="0 0 460 460" height={height} width={width} title={title} fill={fill} {...rest}>
        <g fill={fill} fillRule="nonzero">
            <path
                d="M41.5962012,361.810302 L130.555966,310.371756 C154.024071,339.33557 189.853639,357.845888 230,357.845888 C269.6716,357.845888 305.127901,339.770778 328.606277,311.394914 L417.648847,362.88134 C375.971799,421.653244 307.457326,460 230,460 C152.073143,460 83.1978878,421.186934 41.5962012,361.810302 Z M22.4121734,328.958023 C8.04523607,298.888843 0,265.21162 0,229.652492 C0,108.501776 93.3874579,9.19582518 212,0 L212,102.716707 C149.830247,111.47951 102,164.971885 102,229.652492 C102,246.601055 105.284129,262.78141 111.249827,277.590085 L22.4121734,328.958023 Z"
                fillOpacity="0.3"
            />
            <path d="M437.0202,330.137377 L348.251637,278.809388 C354.532651,263.671269 358,247.067414 358,229.652492 C358,165.667215 311.192596,112.630911 250,103.014779 L250,0.163791552 C367.660625,10.3141676 460,109.183529 460,229.652492 C460,265.677245 451.742689,299.770487 437.0202,330.137377 Z" />
        </g>
    </SVGBase>
);

export default SpotlightLogo;
